import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogoMark } from "@/components/app/Logo";

const LINKS = [["#como-funciona", "Como funciona"], ["#recursos", "Recursos"], ["#preco", "Preço"], ["#contato", "Contato"]];

export const LandingNav = () => (
  <header className="sticky top-0 z-30 border-b border-slate-800/80 bg-slate-950/80 backdrop-blur-xl">
    <div className="mx-auto flex max-w-6xl items-center gap-6 px-4 py-3 sm:px-6">
      <a href="#topo" className="flex items-center gap-2 font-display text-lg font-extrabold tracking-tight" data-testid="landing-brand">
        <LogoMark className="h-8 w-8" /> Ciclo Certo
      </a>
      <nav className="hidden gap-6 text-sm text-slate-300 md:flex">
        {LINKS.map(([href, label]) => <a key={href} href={href} className="transition-colors hover:text-white" data-testid={`landing-nav-${href.slice(1)}`}>{label}</a>)}
      </nav>
      <Button asChild variant="outline" className="ml-auto rounded-full border-slate-600 bg-transparent" data-testid="landing-login-button">
        <Link to="/login">Entrar</Link>
      </Button>
    </div>
  </header>
);
